const Store = require('./models/Store')
const Message = require('./controllers/Message')
const MessageDefinitions = require('./config/MessageDefinitions')
const User = require('./controllers/User')
const config = require('./config/config')
const Helper = require('./controllers/Helper')

var AppModules = function (APP_NAME, NODE_ENV) {
  this.APP_NAME = APP_NAME
  this.NODE_ENV = NODE_ENV
  this.Store = Store
  this.Store.NODE_ENV = NODE_ENV
  this.MessageDefinitions = MessageDefinitions
  this.config = config
  this.Helper = Helper
}

AppModules.prototype.initDb = function (Callback) {
  var self = this
  //
  var initDb = new Promise(function (resolve, reject) {
    return self.Store.initDb(function (err, success) {
      if (err) {
        reject (err)
      }
      resolve(success)
    })
  })
}

AppModules.prototype.clearMessages = function () {
  this.Store.messages = []
}

AppModules.prototype.clearDefinitions = function () {
  delete this.MessageDefinitions
}

AppModules.prototype.getMessage = function (messageTemplate, tradeType, target) {
  const options = {
    template: messageTemplate,
    tradeType: tradeType,
    target: target,
    user: this.Store.getUser(),
    appName: this.APP_NAME,
    store: this.Store,
    helper: this.Helper
  }

  return new Message(options)
}

AppModules.prototype.getUser = function () {
  return this.Store.getUser() || this.Store.setUser(new User(this.APP_NAME, this.NODE_ENV, this.Store, this.Helper))
}

AppModules.prototype.getConfig = function () {
  return this.config
}


// AppModules.prototype.getMediaDashboard = function () {
//   return this.Store.getMediaDashboard() || this.Store.setMediaDashboard(new MediaDashboard(this.APP_NAME, this.NODE_ENV, this.Store.getUser(), this.Store))
// }

module.exports = function (APP_NAME, NODE_ENV) {
  return new AppModules(APP_NAME, NODE_ENV)
}


//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/AppModules.js
// module id = 4
// module chunks = 0